import { render, staticRenderFns } from "./DragItem.vue?vue&type=template&id=476f7f32"
import script from "./DragItem.vue?vue&type=script&lang=js"
export * from "./DragItem.vue?vue&type=script&lang=js"
import style0 from "./DragItem.vue?vue&type=style&index=0&id=476f7f32&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports